<div>
    <div class="modal-body">
      <div class="p-2 text-left">
        <span class="oneinc">One Inc</span>, a trusted third-party payment processor, will help complete your payment. 
        <span class="processingfees">Processing fees apply to payments by Credit or Debit Card.</span>
      </div>
      <div class="p-2 text-left">
        I understand and agree by clicking "Continue" that I will go to the One Inc website to complete a payment. 
        One Inc is the third-party payment solutions provider that will make a payment to Mutual of Enumclaw on my behalf.
      </div>
    </div>
    <div class="modal-footer justify-content-center p-0 pb-2">
      <div class="d-flex">
        <div>
          <button
            type="button"
            class="btn rounded-0 btn-outline px-5"
            (click)="onCancel()"
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn rounded-0 ml-4 px-5"
            (click)="onContinue()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
  